import Text from "aldoo-ra/Text"

export default function Copyright() {
  return (
    <Text
      id="site_copyright"
      variant="txt1_dim"
      className="text-neutral_2 text-center lg:text-left"
      data={{
        product: (
          <a 
            key="product-home" 
            href="/" 
            className="text-neutral_1 hover:text-white transition-colors duration-700"
          >
            Aldoo Snap
          </a>
        ),
        year: new Date().getFullYear(),
      }}
    />
  )
}
